import { DextCheckboxWUT } from '@wix/form-fields/viewer-wut';

export default DextCheckboxWUT;
